// extracted by mini-css-extract-plugin
export var printerCard = "_aj-1";
export var printerCardConfigured = "_aj-2";
export var printerCardError = "_aj-3";
export var printerCardsContainer = "_aj-0";
export var printerIcon = "_aj-8";
export var printerIconConfigured = "_aj-5";
export var printerIconContainer = "_aj-4";
export var printerIconError = "_aj-6";
export var printerIconUnconfigured = "_aj-7";
export var workstationsTableCard = "_aj-9";